import axios from 'axios'

class StaticAPI {
  getProfileSelects = async params => {
    return axios.get('api/profile-selects', { params })
  }
}

export const staticAPI = new StaticAPI()
